interface GeoResult {
  city: string | null
  country: string | null
  countryCode: string | null
}

export async function reverseGeocode(lat: number, lng: number): Promise<GeoResult> {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&accept-language=fr`,
      { headers: { 'User-Agent': 'KeepTouch/1.0' } },
    )
    if (!res.ok) return { city: null, country: null, countryCode: null }
    const data = await res.json()
    const addr = data.address || {}
    return {
      city: addr.city || addr.town || addr.village || addr.municipality || null,
      country: addr.country || null,
      countryCode: addr.country_code?.toUpperCase() || null,
    }
  } catch {
    return { city: null, country: null, countryCode: null }
  }
}
